export default "__VITE_ASSET__D21THR4C__"